import { styled, Box, Typography, Stack, Button, Skeleton } from "@mui/material";
import TileIcon from "../../assets/images/TileIcon.svg";
import GenAI from "../../assets/images/GenAI.svg";
import { capitalizeWord } from "./myPerformanceHelpers";

const ColorButton = styled(Button)(() => ({
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  color: "#191919",
  borderRadius: "4px",
  padding: "10px",
  border: "1px solid #6D94A7",
  "& .MuiButton-startIcon": { mr: 1 },
  "&:hover": {
    backgroundColor: "#CAD6DC",
    border: "1px solid #6D94A7",
  },
}));

export default function MyPerformanceWelcomeBanner({
  firstName,
  nameLoading = false,
  onExploreHcpClick,
}) {
  return (
    <Box className="welcome-banner" sx={{}}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 550,
              lineHeight: 1.2,
              color: "#274858",
              fontSize: "18px",
            }}
          >
            Welcome,{" "}
            {nameLoading ? (
              <Skeleton
                variant="text"
                width={72}
                height={22}
                animation="wave"
                sx={{ display: "inline-block", verticalAlign: "middle" }}
              />
            ) : (
              capitalizeWord(firstName)
            )}
          </Typography>
          <Typography
            variant="body2"
            color="#274858"
            title="RepAssist is here to help. Ask a question or make a request to generate response."
            sx={{ mt: "4px" }}
          >
            RepAssist is here to help. Ask a question or make a request to
            generate response.
          </Typography>
          <ColorButton
            variant="contained"
            sx={{
              backgroundColor: "#FFFFFF",
              border: "none",
              boxShadow: "1px 4px 4px 0px #00000008",
              mt: 2,
              pr: 2,
              pl: 2,
              "&:hover": {
                borderColor: "#3a6e86",
                color: "#3a6e86",
                backgroundColor: "#FFFFFF",
              },
            }}
            startIcon={<Box component="img" src={TileIcon} alt="tile-icon" />}
            onClick={onExploreHcpClick}
          >
            Explore HCPs to Engage
          </ColorButton>
        </Box>
      </Stack>
      <Box
        sx={{
          alignSelf: "baseline",
          width: 65,
          height: 65,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={GenAI}
          alt="GenAI"
          sx={{ width: 65, height: 64, display: "block" }}
        />
      </Box>
    </Box>
  );
}
